export const formatScheduledTime = (isoString: string, timezone?: string): string => {
  try {
    const date = new Date(isoString);
    return date.toLocaleTimeString('es-MX', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ...(timezone ? { timeZone: timezone } : {}),
    });
  } catch {
    return isoString;
  }
};

export const formatScheduledDateTime = (isoString: string, timezone?: string): string => {
  try {
    const date = new Date(isoString);
    return date.toLocaleDateString('es-MX', {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ...(timezone ? { timeZone: timezone } : {}),
    });
  } catch {
    return isoString;
  }
};

export const getScheduledPrintLabel = (
  isScheduled?: boolean,
  scheduledDeliveryTime?: string,
  timezone?: string,
): string | null => {
  if (!isScheduled || !scheduledDeliveryTime) return null;
  const time = formatScheduledDateTime(scheduledDeliveryTime, timezone);
  return `PROGRAMADO — Entregar a las ${time}`;
};
